import React, { useState } from 'react'
import { useFormik } from 'formik';
import { Spinner } from 'react-bootstrap';
import { CertificateSchema } from './CertificateManagementSchema';
import { addTemplateRes, addTemplateTodo } from '../../LMS_Redux/LMS_Slices/Certificate/AddTemplate';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { uploadRes, uploadTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadImage';

export default function AddTemplate() {

    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        // heading: '',
        // certificate_border: '',
        // border_color: '#000000',
        // background_img: '',
        // logo: '',
        // logo_allignment: '',
        hod_name: '',
        signature: ''
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: CertificateSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addTemplateTodo(values)).then(() => add_res())
        },
    })

    const add_res = () => {
        // console.log(addUpdateGroupRes)
        if (addTemplateRes && addTemplateRes.success) {
            toast.success(addTemplateRes.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                navigate('/certificate_template_list')
            }, 2000);

        } else {
            toast.error(addTemplateRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    const uploads = (file, type) => {
        if (file) {
            dispatch(uploadTodo(file)).then(() => upload_res(type))
        }
    }

    const upload_res = (type) => {
        // console.log(uploadRes)
        if (uploadRes && uploadRes.success) {
            setFieldValue(type, uploadRes.data.path)
            toast.success(uploadRes.message, { position: "bottom-right" })
        } else {
            toast.error(uploadRes.message, { position: "bottom-right" })
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Certificate</span>
                </div>
                <div className='wrapper-admin'>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                        <div className="row">

                            {/* <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="heading" className="form-label form_label">Heading</label>
                                    <input type="text" className="form-control form_input" placeholder="Enter Heading" id='heading'
                                        name='heading' value={values.heading} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.heading && touched.heading ? (<span className='text-danger form_label'>{errors.heading}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label htmlFor="border" className="form-label form_label">Border</label>
                                <select className="form-select form_input" aria-label="Default select example" id='border'
                                    name='certificate_border' value={values.certificate_border} onChange={handleChange} onBlur={handleBlur}
                                >
                                    <option value="">Select Border</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                {errors.certificate_border && touched.certificate_border ? (<span className='text-danger form_label'>{errors.certificate_border}</span>) : null}
                            </div>

                            <div className="col-12 col-md-2">
                                <div className="mb-3">
                                    <label htmlFor="color" className="form-label form_label">Border Color</label>
                                    <input type="color" className="form-control form_input" placeholder="Enter Heading" id='color'
                                        name='border_color' value={values.border_color} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.border_color && touched.border_color ? (<span className='text-danger form_label'>{errors.border_color}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="bg-img" className="form-label form_label">Background Image</label>
                                    <input type="file" className="form_input form-control file" placeholder="" id='bg-img'
                                        name='background_img' onChange={(e) => uploads(e.currentTarget.files[0], "background_img")} onBlur={handleBlur}
                                        accept="image/jpg, image/jpeg, image/png"
                                    />
                                    {errors.background_img && touched.background_img ? (<span className='text-danger form_label'>{errors.background_img}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="logo" className="form-label form_label">Logo</label>
                                    <input type="file" className="form_input form-control file" placeholder="" id='logo'
                                        name='logo' onChange={(e) => uploads(e.currentTarget.files[0], "logo")} onBlur={handleBlur}
                                        accept="image/jpg, image/jpeg, image/png"
                                    />
                                    {errors.logo && touched.logo ? (<span className='text-danger form_label'>{errors.logo}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label htmlFor="logo-align" className="form-label form_label">Logo Allignment</label>
                                <select className="form-select form_input" aria-label="Default select example" id='logo-align'
                                    name='logo_allignment' value={values.logo_allignment} onChange={handleChange} onBlur={handleBlur}
                                >
                                    <option value="">Select Allignment</option>
                                    <option value="center">Center</option>
                                    <option value="left">Left</option>
                                    <option value="right">Right</option>
                                </select>
                                {errors.logo_allignment && touched.logo_allignment ? (<span className='text-danger form_label'>{errors.logo_allignment}</span>) : null}
                            </div> */}

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="hod-name" className="form-label form_label">HOD Name</label>
                                    <input type="text" className="form-control form_input" placeholder="Enter HOD Name" id='hod-name'
                                        name='hod_name' value={values.hod_name} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.hod_name && touched.hod_name ? (<span className='text-danger form_label'>{errors.hod_name}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="signature" className="form-label form_label">Signature</label>
                                    <input type="file" className="form_input form-control file" placeholder="" id='signature'
                                        name='signature' onChange={(e) => uploads(e.currentTarget.files[0], "signature")} onBlur={handleBlur}
                                        accept="image/jpg, image/jpeg, image/png"
                                    />
                                    {errors.signature && touched.signature ? (<span className='text-danger form_label'>{errors.signature}</span>) : null}
                                </div>
                            </div>

                            <div className='text-end mt-3'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <ToastContainer />
        </>
    )
}
